import { LoginPage } from './components/LoginPage';
import { RedirectPage } from './components/RedirectPage';
import { UnauthorizedPage } from './components/UnauthorizedPage';
import { AuthenticationModuleClientType } from '../../../types';

export const AuthenticationModuleMockedClient: AuthenticationModuleClientType = {
  LoginPage,
  RedirectPage,
  UnauthorizedPage
};
